import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { QUIZ_EVENT, getQuizBody } from "components/Quiz/utils";
import { SELLER_ADDRESS_LOCALSTORAGE_KEY } from "components/Tiles/constants";
import { useAnalytics } from "context/AnalyticsContext";
import { APP_LANGUAGES } from "utils/language";
import { QuizQuestion } from "../quizTypes";

// TODO: add analytics later
const useQuizSubmission = (quizSlug: string, quizLanguage = APP_LANGUAGES.ENGLISH) => {
  const router = useRouter();
  const { track } = useAnalytics();
  const handleSubmit = useCallback(
    async (payload: QuizQuestion[], shouldRedirect = true) => {
      try {
        const { quizBody, clientDetails, webhookURL, deal, redirectLink, isQuizValid } = getQuizBody({
          questions: payload,
          quizLanguage
        });

        if (!isQuizValid) {
          return { error: "Submission invalid" };
        }

        const webhookPayload = {
          user: { ...clientDetails },
          deal: deal,
          questions: quizBody,
          quizType: quizSlug
        };
        let response;
        if (webhookURL) {
          // SEND PAYLOAD TO Make hook
          response = await fetch(webhookURL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(webhookPayload)
          }).then((res) => res.json());
        }
        if (typeof window !== "undefined") {
          localStorage.removeItem(SELLER_ADDRESS_LOCALSTORAGE_KEY);
        }
        track({
          eventName: QUIZ_EVENT.QUIZ_COMPLETED,
          properties: {
            quiz_type: quizSlug,
            form_title: quizSlug,
            clientDetails
          }
        });

        if (shouldRedirect) {
          // if webhook return a redirectLink use that to redirect
          if (response?.redirectTo) {
            router.replace(response.redirectTo);
          } else {
            router.replace(redirectLink);
          }
        }
        return response;
      } catch (error) {
        return { error: "Submission invalid" };
      }
    },
    [quizSlug, router, track, quizLanguage]
  );

  return {
    handleSubmit
  };
};

export default useQuizSubmission;
